/* TENSO theme — minimal interactions */
(function(){
  "use strict";

  /* The two drawers are mutually exclusive.

     They slide from opposite edges and both sit above the page, so opening one
     while the other was open left the nav visible down the side of the bag — two
     panels fighting over the same screen. Each open() now closes the other
     first. Both have their own CSS transition, so one slides out as the other
     slides in without anything being coordinated in JS.

     They talk through window.tensoNavClose / window.tensoCartClose rather than
     reaching into each other's internals; either can be missing and the caller
     just does nothing. */

  /* Cart drawer open/close */
  function bindDrawer(){
    var drawer=document.getElementById('CartDrawer');
    var scrim=document.getElementById('CartScrim');
    if(!drawer) return;
    function open(){
      if(window.tensoNavClose) window.tensoNavClose();
      drawer.classList.add('open');scrim.classList.add('open');document.body.style.overflow='hidden';
    }
    function close(){drawer.classList.remove('open');scrim.classList.remove('open');document.body.style.overflow='';}
    document.querySelectorAll('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();open();});});
    document.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',close);});
    if(scrim) scrim.addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    window.tensoCartOpen=open;
    window.tensoCartClose=close;
  }

  /* Mobile nav drawer — delegated so it survives theme-editor section reloads.
     The menu mark is both the open and the close control. */
  function bindNav(){
    function drawer(){return document.getElementById('NavDrawer');}
    function scrim(){return document.getElementById('NavScrim');}
    function isOpen(){var d=drawer();return !!d&&d.classList.contains('open');}
    function setExpanded(v){
      document.querySelectorAll('[data-nav-toggle]').forEach(function(b){b.setAttribute('aria-expanded',v);});
    }
    function open(){
      var d=drawer(),s=scrim();
      if(!d) return;
      if(window.tensoCartClose) window.tensoCartClose();
      d.classList.add('open');d.setAttribute('aria-hidden','false');
      if(s) s.classList.add('open');
      document.body.classList.add('nav-open');
      document.body.style.overflow='hidden';
      setExpanded('true');
    }
    function close(){
      var d=drawer(),s=scrim();
      if(d){d.classList.remove('open');d.setAttribute('aria-hidden','true');}
      if(s) s.classList.remove('open');
      document.body.classList.remove('nav-open');
      document.body.style.overflow='';
      setExpanded('false');
    }
    document.addEventListener('click',function(e){
      if(!e.target.closest) return;
      if(e.target.closest('[data-nav-toggle]')){e.preventDefault();isOpen()?close():open();return;}
      if(e.target.id==='NavScrim') close();
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    window.tensoNavClose=close;
  }

  /* PDP gallery thumbnail swap */
  function bindGallery(){
    var main=document.querySelector('.gallery .main img');
    if(!main) return;
    document.querySelectorAll('.gallery .thumb').forEach(function(t){
      t.addEventListener('click',function(){
        var src=t.querySelector('img').getAttribute('src');
        main.setAttribute('src',src);
        document.querySelectorAll('.gallery .thumb').forEach(function(x){x.classList.remove('active');});
        t.classList.add('active');
      });
    });
  }

  /* Quantity stepper */
  function bindQty(){
    document.querySelectorAll('.qty').forEach(function(q){
      var input=q.querySelector('input');
      var btns=q.querySelectorAll('button');
      if(!input||btns.length<2) return;
      btns[0].addEventListener('click',function(){input.value=Math.max(1,(parseInt(input.value,10)||1)-1);});
      btns[1].addEventListener('click',function(){input.value=(parseInt(input.value,10)||1)+1;});
    });
  }

  /* Variant pickers (size / colourway) -> hidden id + price */
  function bindVariants(){
    var form=document.querySelector('[data-product-form]');
    if(!form) return;
    var data=form.getAttribute('data-variants');
    if(!data) return;
    var variants;try{variants=JSON.parse(data);}catch(e){return;}
    function selected(){
      var opts=[];
      form.querySelectorAll('[data-option]').forEach(function(group){
        var active=group.querySelector('.active');
        if(active) opts.push(active.getAttribute('data-value'));
      });
      return opts;
    }
    function match(){
      var opts=selected();
      return variants.find(function(v){return v.options.every(function(o,i){return o===opts[i];});});
    }
    function update(){
      var v=match();var idEl=form.querySelector('[name="id"]');
      if(v&&idEl) idEl.value=v.id;
    }
    form.querySelectorAll('[data-option] [data-value]').forEach(function(el){
      el.addEventListener('click',function(){
        var group=el.closest('[data-option]');
        group.querySelectorAll('[data-value]').forEach(function(x){x.classList.remove('active');});
        el.classList.add('active');
        var lab=group.parentNode.querySelector('.opt-label .val');
        if(lab) lab.textContent=el.getAttribute('data-value');
        update();
      });
    });
    update();
  }

  document.addEventListener('DOMContentLoaded',function(){
    bindDrawer();bindNav();bindGallery();bindQty();bindVariants();
  });
})();
